/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Empty/view.blocks to change it.
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import useIsMedia from 'Simple/hooks/useIsMedia'



/** @type {import('Simple/types.js').View} */
export default function Empty({
  children,
  viewPath = "/DesignSystem/PreviewDocumentModal/Empty"
  
}) {
  let isMedia = useIsMedia()
  return (<React.Fragment
>
<div
  data-testid="Empty.Vertical"
  data-view-path={viewPath}
 style={{'--ai-1-4PwO0': isMedia.mobile ? "flex-start" : "center",'--jc-2-4PwO0': isMedia.mobile ? "flex-start" : "center"}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="large"
 text="Please select a file for preview"
/>
</div>
{children}
</React.Fragment>)
}